import { render, staticRenderFns } from "./QuickViewModal.vue?vue&type=template&id=6988df32&"
import script from "./QuickViewModal.vue?vue&type=script&lang=js&"
export * from "./QuickViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6988df32')) {
      api.createRecord('6988df32', component.options)
    } else {
      api.reload('6988df32', component.options)
    }
    module.hot.accept("./QuickViewModal.vue?vue&type=template&id=6988df32&", function () {
      api.rerender('6988df32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/modals/QuickViewModal.vue"
export default component.exports